// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pageheader[data-v-9afdb4b4] {\n  background: #fff;\n  padding: 16px 10px 0;\n  border-bottom: 1px solid #e8e8e8;\n  border-left: 1px solid #e8e8e8;\n}\n.pageheader .title[data-v-9afdb4b4] {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 28px;\n  margin-bottom: 16px;\n  -webkit-box-flex: 1;\n      -ms-flex: auto;\n          flex: auto;\n}\n", ""]);
// Exports
module.exports = exports;
